import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {ChangeArgs, RadioButtonComponent} from "@syncfusion/ej2-vue-buttons";
import {onMounted, ref} from "vue";

interface Props {
  label?: string,
  modelValue?: string,
  name?: string
  value?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SogRadioButton',
  props: {
    label: { default: undefined },
    modelValue: { default: undefined },
    name: { default: undefined },
    value: { default: undefined }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const _checked = ref(false)

function change(args: ChangeArgs) {
//  console.log(args);
  emit('update:modelValue', args.value)
}

onMounted(() => {
  _checked.value = props.modelValue === props.value
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(RadioButtonComponent), {
      value: __props.value,
      label: __props.label,
      name: __props.name,
      checked: _checked.value,
      onChange: change
    }, null, 8, ["value", "label", "name", "checked"])
  ]))
}
}

})